import { ViewFactory } from 'wdc-cube-react'

import { UserProfileScope } from '../up_scopes'

import { HeaderScope } from '../up_scopes'
import UserProfileView from './up_view'
import HeaderView from './up-header'

export function registerViews(rv = ViewFactory.register) {
    rv(UserProfileScope, UserProfileView)
    rv(HeaderScope, HeaderView)
}
